/**
 * Types and default values for subscription context
 * This file contains types shared between components
 */

export interface SubscriptionContextType {
  isSubscribed: boolean;
  isLoading: boolean;
  isTrialing: boolean;
  checkSubscription: () => Promise<void>;
  hasSeenModalRecently: () => boolean;
  getTimeSensitiveOffer: () => TimeSensitiveOffer | null;
  trackPaywallHit: (feature: string) => void;
  openPricingModal: (source?: string) => void;
  incrementQueryCount: () => number; // Method to increment query count and update localStorage
  modalState: PricingModalState;
  setModalState: (state: PricingModalState | ((prev: PricingModalState) => PricingModalState)) => void;
  queryCount: number;
  queryLimit: number;
  calendarDaysLimit: number;
}

export interface TimeSensitiveOffer {
  discount: string;
  expiresIn: string;
  message: string;
}

export interface PricingModalState {
  isPricingOpen: boolean;
  source: string;
  timeSensitiveOffer: TimeSensitiveOffer | null;
}

// Default value for the context
export const subscriptionContextDefault: SubscriptionContextType = {
  isSubscribed: false,
  isLoading: true,
  isTrialing: false,
  checkSubscription: async () => {},
  hasSeenModalRecently: () => false,
  getTimeSensitiveOffer: () => null,
  trackPaywallHit: () => {},
  openPricingModal: () => {},
  incrementQueryCount: () => 0,
  modalState: {
    isPricingOpen: false,
    source: '',
    timeSensitiveOffer: null
  },
  setModalState: () => {},
  queryCount: 0,
  queryLimit: 0,
  calendarDaysLimit: 0
};
